import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
// import Products from "./Products";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Navbar from "./pages/Navbar";
import Products from "./pages/Products";
import Footer from "./Footer";
import Reviews from "./pages/Reviews";
<Route path="/products" element={<Products />} />




function App() {
  return (
    <Router>
      <Navbar /> 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/reviews" element={<Reviews />} />
      </Routes>
      
        <Footer />
    </Router>
    
  );
}

export default App;
